import useSWR from 'swr'
import { RegionDataType } from './useRegionMaster';
import { GetSessionID } from '../Utility/SessionUtility';

/**
 * 初期ロードデータの型
 */
export interface InitType {
    country_data: Array<CountryDataType>,
    region_data: Array<RegionDataType>,
    fiscalyear: number,
    fiscal_year_list: Array<FiscalYearListType>,
    advance_start_period: string,
    advance_end_period: string,
    register_start_period: string,
    register_end_period: string,
}

/**
 * 国情報の型
 */
export interface CountryDataType {
        id: number,
        country_name: string,
        country_name_en: string,
        region_id: number,
        country_code2: string,
        country_code3: string,
        dropdown_disp: string,
        target_year: number,
}

/**
 * 年度情報の型
 */
export interface FiscalYearListType {
    id:number,
    target_year:string
}

/**
 * 初期ロードデータHook
 */
export function useInit() {

    const fetchAddress = `/competition/api/management/init?sessionId=${GetSessionID()}`

    const fetcher = () => fetch(fetchAddress).then(res => res.json());

    const {data, error, isLoading, mutate} = useSWR("Init", fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        /**
         * 初期ロードデータ
         */
        init: data,
        
        /**
         * ロード中フラグ
         */
        isLoading,

        /**
         * エラーフラグ
         */
        isError: error,

        /**
         * 再取得関数
         */
        mutate,
    }
}